import api from "../../index";

export const GetProvinceListApi = (data) => api.post('taxratelist', data);
export const AddUpdateProvinceApi = (data) => api.post('addupdatetaxrate', data);
export const DeleteProvinceApi = (data) => api.post('deletetaxrate', data);